// TODO: Add '@cloudinary/react' or '@cloudinary/url-gen' for the React component?

// from https://console.cloudinary.com/pm/c-3a1094b6d1e2fe8a119d7fb13c0694
const CLOUDINARY_IMAGE_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/ds3doqkmr/image/upload';

export type UPLOAD_PRESET = 'event-image' | 'team-image';

export const uploadImage = async (
    file: File,
    preset: UPLOAD_PRESET,
    tags: string[],
): Promise<UploadImageResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', preset);
    formData.append('tags', tags.join(','));

    const response = await fetch(CLOUDINARY_IMAGE_UPLOAD_URL, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        throw new Error('Failed to upload image');
    }

    const json = (await response.json()) as UploadImageResponse;
    return json;
};

export interface UploadImageResponse {
    asset_id: string;
    public_id: string;
    version: string;
    version_id: string;
    signature: string;
    width: string;
    height: string;
    format: string;
    resource_type: string;
    created_at: string;
    tags: [];
    pages: 1;
    bytes: string;
    type: string;
    etag: string;
    placeholder: false;
    url: string;
    secure_url: string;
    asset_folder: string;
    display_name: string;
    image_metadata: {
        JFIFVersion: string;
        ResolutionUnit: string;
        XResolution: string;
        YResolution: string;
        Colorspace: string;
        DPI: string;
    };
    illustration_score: 0.0;
    semi_transparent: false;
    grayscale: false;
    original_filename: string;
}
